import { makeStyles } from '@material-ui/core';

export const useCreationStyles = makeStyles(theme => ({
  icon: { marginRight: theme.spacing(0.5) },
  divider: { margin: theme.spacing(2, 0) },
  field: {
    marginBottom: theme.spacing(2),
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
  },
  modeToggle: {
    marginBottom: theme.spacing(2),
  },
  wiSection: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  wiChip: {
    marginBottom: theme.spacing(1),
  },
  wiPreview: {
    marginTop: theme.spacing(1.5),
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(3),
  },
}));
